export class WlTextValueAdded extends CustomEvent<EventInit> {

    static type: string = 'wl-text-value-added';
    input: HTMLInputElement;

    constructor(input: HTMLInputElement) {
        super(WlTextValueAdded.type, {bubbles: true, composed: true});
        this.input = input;
    }
}
